module.exports = __webpack_public_path__ + "img/Training_courses_img_3.6ab04505.jpg";